import { appPayMethod, i18n, outputDiv, reCAPTCHAv3, loading } from "commonAssets/js/constants";
import { DigitalDisbursements } from "commonAssets/components/FormBase/DigitalDisbursements";
import { FormFields, FormFieldsLabel } from "commonAssets/components/FormBase/FormFields";
import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { dstMember, dstPaymentIframeTitle } from "commonAssets/components/FormBase/DigitalDisbursements";
import { createElement } from "commonAssets/lib/createElement";
import { toggleFieldAttributeV2 } from "commonAssets/lib/toggleFieldAttributeV2";
import { loadingGif } from "commonAssets/lib/loadingGif";
import { loadMember } from "commonAssets/lib/loadMember";
import { uniformClaimDeadline } from "commonAssets/lib/uniformClaimDeadline";
import { ConfirmEmailAddress } from "commonAssets/lib/ConfirmEmailAddress";
import { clearMessage } from "commonAssets/lib/clearMessage";
import { localDatetime } from "commonAssets/lib/localDatetime";
import { modal } from "commonAssets/lib/modal";
import { validateField } from "commonAssets/lib/validateField";
import { uploadFile } from "commonAssets/lib/uploadFile";
import { ErrorHandler } from "commonAssets/utils/ErrorHandler";
import formDefault from "../../docs/formDefault.json";

const hasSimplifiedCampaignParams = (() => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('utm_source') === 'notice' &&
           urlParams.get('utm_medium') === 'email' &&
           urlParams.get('utm_campaign') === 'simplified_version';
})();

const deviceType = (() => {
    const ua = navigator.userAgent.toLowerCase();
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    
    // Check for mobile/tablet devices
    const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua);
    const isTablet = /ipad|android(?!.*mobile)|tablet/i.test(ua) || (isMobile && width >= 768);
    
    if (isTablet) return 'tablet';
    if (isMobile) return 'mobile';
    return 'desktop';
})();

console.log(deviceType);

export class customSubmitClaim extends SubmitClaim {
    async form() {
        const form = formDefault.claim_form[this.lang];
        this.init_claim(form);
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }

    claim_form(params, additionalParams) {
        console.log('custom claim form')
        console.log("[claim_form]")
        // update the claim form deadline
        const deadline_heading = params.form_options.claim_deadline_alert.claim_form;
        const deadline_parser = new DOMParser();
        const deadline_string = deadline_parser.parseFromString(deadline_heading, "text/html");
        const deadline_date_string = deadline_string.querySelector("span");
        // if deadline_date_string is null, then the deadline is not set
        // the if condition was added due to error in i18n translation
        // TODO: remove this if condition after fixing the i18n translation
        if (deadline_date_string !== null) {
            deadline_date_string.textContent = additionalParams;
        }

        // const the form
        const form = createElement("form", {
            class: "needs-validation",
            id: "form",
            method: "post"
        }, [
            createElement("h3", {
                class: "text-center mb-3",
                id: "claimFormDeadline"
            }, [], deadline_string.body.innerHTML),
            createElement("div", {
                class: "alert alert-info text-center fw-bold text-dark",
                id: "confirmation-email-alert",
                role: "alert"
            }, [], params.form_options.claim_form.confirmation_email_notice),
            this.claim_instructions(params),
            this.claim_contact_information(params),
            this.claim_fieldset(params),
            //params.claim_transactions ? this.claim_transactions(params) : ``,
            params.claim_upload.documentation.required ? this.claim_documentation(params) : ``,
            appPayMethod ? DigitalDisbursements(params) : ``,
            this.claim_certification(params),
        ]);
        return form;
    }

    claim_fieldset(params) {
        if (params.claim_fields_sectioned === undefined) {
            return createElement("div", { class: "d-none" });
        }
        if (params.claim_fields_sectioned.length === 0) {
            return createElement("div", { class: "d-none" });
        }
        const claimFields = createElement("div", {
            id: "claim-fields"
        }, [
            this.claim_field_sections(params)
        ])
        return claimFields;
    }

    claim_field_sections(params) {
        const claimFieldSections = createElement("div", {});

        params.claim_fields_sectioned.forEach((section) => {
            claimFieldSections.append(createElement("fieldset", { class: "bg-light text-dark border rounded p-3 mb-5" }, [
                createElement("div", { class: "h3 mb-3 formTitle" }, [], section.title),
                createElement("div", { class: "mb-3 formBody" }, [], section.body),
                this.claim_fields(section.fields),
            ]))
        })
        return claimFieldSections;
    }

    claim_fields(fields) {
        const container = createElement("div");

        let fieldID = 0;  //
        fields.forEach(field => {
            let element;
            let validation;
            let className = field.className ? field.className : ``;

            const div = createElement("div", {
                class: (field.parentClass ? field.parentClass : "mb-3 _wrapper"),
                "data-field-id": "_" + (field.name ? field.name : "_wrapper_" + fieldID)
            });
            element = FormFields(field, className, fieldID, element, validation, container);
            FormFieldsLabel(field, fieldID, div);

            div.append(element);
            container.appendChild(div);
            fieldID++;
        });

        return container;
    }

    claim_transactions(params, transaction_id) {
        if (params.claim_transactions === undefined) {
            return createElement("div", { class: "d-none" });
        }
        if (params.claim_transactions.length === 0) {
            return createElement("div", { class: "d-none" });
        }

        const fieldset = createElement("div", {
            class: "bg-light text-dark border rounded p-3 mb-5",
            id: `transactions-${transaction_id}`
        }, [
            // createElement("div", {
            //     class: "h3 mb-3 formTitle",
            // }, [], params.form_options.transactions.title),
            // createElement("div", {
            //     class: "mb-3 formBody"
            // }, [], params.form_options.transactions.body),
        ]);

        // For Each Transaction Table
        const claim_transactions = params.claim_transactions;
        let tableID = 0;
        claim_transactions.forEach(table => {
            tableID++; // Begin count at 1.
            if (tableID != transaction_id) return;

            // <div class="table-responsive"></div>
            const divResponsiveTable = createElement("div", { class: "table-responsive mb-3", id: "table_responsive_" + tableID });

            // <table class="table transactions"></table>
            const tableTransaction = createElement("table", {
                class: "table table-hover transactions caption-top",
                id: "transactions_" + tableID,
                "data-table-name": table.name,
                "data-table-id": tableID,
            }, [
                //createElement("caption", { class: "text-dark bg-transparent" }, [], "<strong>" + table.name + "</strong> &mdash; " + table.description),
            ]);
            divResponsiveTable.appendChild(tableTransaction);

            // <thead class="bg-dark text-light"></thead>
            const tableTHEAD = createElement("thead", { class: "table-dark text-light" });
            tableTransaction.appendChild(tableTHEAD);

            // <tr> ...Table Data Cells... </tr>
            const theadTR = createElement("tr");
            tableTHEAD.appendChild(theadTR);

            // <th scope="col"></th>
            table.columns.forEach(col => {
                const column = createElement("th", { scope: "col" }, [], col.title);
                theadTR.appendChild(column);

                if (Boolean(col.body)) {
                    const helper = createElement("span", { class: "d-block fw-normal", style: "font-size:16px;" }, [], col.body);
                    column.appendChild(helper);
                }
            });

            // <tbody></tbody>
            const tableTBODY = createElement("tbody");
            tableTransaction.appendChild(tableTBODY);

            // Add rows through a function, so we can attach a button.
            let countRow = 1;
            this.claim_transaction_row(table, tableTBODY, tableID, countRow);

            const add_row = createElement("div", {
                class: "text-center",
            }, [
                createElement("a", {
                    class: "btn btn-primary m-1",
                    id: "add_transactions_" + tableID,
                    role: "button",
                    tabindex: "0",
                    "aria-label": i18n.getTranslation('transaction_add_row') + table.name,
                    "tableID": tableID,
                }, [], `<i class="bi bi-plus-circle" tableID="${tableID}"></i> Add Row`),
                createElement("a", { // ada compliance updates - added
                    class: "btn btn-danger m-1 disabled", // default to disabled
                    id: "remove_transactions_" + tableID,
                    role: "button",
                    tabindex: "0",
                    "aria-label": i18n.getTranslation('transaction_delete_row'),
                    "tableID": tableID,
                }, [], `<i class="bi bi-dash-circle" tableID="${tableID}"></i> ${i18n.getTranslation('transaction_delete_row')}`),
            ])

            // ada compliance updates - added
            this.claim_transaction_row_buttons_events(add_row, table, tableTBODY, tableID, countRow);

            // Append the table to the fieldset
            fieldset.appendChild(divResponsiveTable);
            fieldset.appendChild(add_row);
        });

        return fieldset;
    }

    claim_transaction_row(table, tableTBODY, tableID, countRow) {
        const fieldsRow = createElement("tr", {
            class: "transaction-row", // ada compliance updates - added
            id: "transaction_row_" + tableID + "_" + countRow, // ada compliance updates - added
        });
        tableTBODY.appendChild(fieldsRow);
        let fieldID = 0;
        table.fields.forEach(field => {
            fieldID++;
            let td = createElement("td", { class: "transaction " + field.name, });
            let element = createElement("div");
            let validation = field.validation;
            let formInput = FormFields(field, "", fieldID, element, validation, fieldsRow);
            // set unique name for each field
            field.name = field.name + "__" + countRow;
            FormFieldsLabel(field, fieldID, element);
            // set unique id for each field
            formInput.id = formInput.id + "__" + countRow;
            // set item-id attribute
            formInput.setAttribute("item-id", countRow);
            if (countRow != 1) {
                toggleFieldAttributeV2(formInput, 'required', true);
            }
            if (formInput.type === 'date') {
                const today = new Date().toISOString().split('T')[0];
                formInput.setAttribute('max', today);
                formInput.setAttribute('data-date-max', today);
                formInput.setAttribute('data-validate', formInput.getAttribute('data-validate') + ' date-max');
            }
            formInput.addEventListener('change', (e) => {
                validateField(e.target);
            });
            element.appendChild(formInput);
            td.appendChild(element);
            fieldsRow.appendChild(td);
        });
        return { tableTBODY, fieldsRow };
    }

    populate_claim_form(form, container, class_member, claim_deadline) {
        console.log("[populate_claim_form]");
        // set user for error tracking
        this.errorHandler.set_user({ id: class_member.zero_zero_id, email: class_member.email_address });
        // remove guard
        document.getElementById('guard').remove();
        // claim_deadline format December 31, 2024 at 04:00:00 P.M. 
        let deadlineSpan = uniformClaimDeadline(claim_deadline);
        // New Claim Form
        container.appendChild(this.claim_form(form, deadlineSpan));
        container.scrollIntoView({ behavior: "smooth" });
        // output
        outputDiv.appendChild(container);
        // hide loading gif
        loadingGif(loading, "hide", 250);
        // Init claim fields
        this.init_claim_fields(this.claim, form, claim_deadline);
        // Load member data into form
        loadMember(class_member);
        // custom login member code
        if (!class_member.claim_type || class_member.claim_type == 'login') {
            document.getElementById('first_name').disabled = document.getElementById('first_name').value;
            document.getElementById('last_name').disabled = document.getElementById('last_name').value;
            // Append text to first p child of #contactInfoBody
            const contactInfoBody = document.getElementById('contactInfoBody');
            if (contactInfoBody) {
                const firstParagraph = contactInfoBody.querySelector('p');
                if (firstParagraph) {
                    firstParagraph.innerHTML += ' If you would like to change your name, please send relevant documentation to the Settlement Administrator at <a href="mailto:Info@MidAmericaPetFoodSettlement.com">Info@MidAmericaPetFoodSettlement.com</a>.';
                }
            }
        }
        // Payment widget 
        if (appPayMethod && appPayMethod !== "") {
            dstMember();
        }
        if (class_member.claim_id) {
            if (class_member?.claim_files?.length > 0) this.claim.prev_docs = true;

            if (document.getElementById('business_name').value) {
                const businessName = document.getElementById('business_name').value.trim();
                const certBusinessNameInput = document.getElementById('cert_business_name');
                const signatureInput = document.getElementById('signature');
                const certBusinessSignatureInput = document.getElementById('business_signature');
                certBusinessNameInput.value = businessName;

                toggleFieldAttributeV2(certBusinessSignatureInput, 'required', true);
                toggleFieldAttributeV2(signatureInput, 'required', false);
            }
        }
    }

    init_claim_fields(claim, form, claim_deadline) {
        console.log(hasSimplifiedCampaignParams);

        // Claim Inputs
        this.init_claim_inputs();

        // Loop thru available inputs
        this.init_claim_inputs_loop();

        // Validate phone number
        this.setup_phone_number_validation();

        // Country field toggle
        this.setup_country_field_toggle();

        // Confirm email address
        if (document.getElementById('email_address') && document.getElementById('confirm_email_address')) {
            ConfirmEmailAddress('init');
        }

        // Check for file documentation section
        if (document.getElementById('documentation')) {
            // Initialize file uploads
            this.init_claim_files(this.claim);
        }

        dstPaymentIframeTitle(form);

        if (Boolean(document.getElementById("form"))) {
            document.getElementById('form').setAttribute('novalidate', 'true');

            // ada compliance updates - added
            // TODO: review if this is where this belongs
            // if id="submit-claim" is clicked, add was-validated to form class
            // document.getElementById("submit-claim").addEventListener('click', () => {
            //     document.getElementById("form").classList.add("was-validated");
            // });

            document.getElementById("form").addEventListener('submit', (process) => {
                this.process_claim(process, this.claim, claim_deadline);
            });
        }

        document.querySelectorAll('div[class^="transactions_"]').forEach((tableDiv) => {
            tableDiv.appendChild(this.claim_transactions(form, tableDiv.getAttribute('class').split('_')[1]));
        });

        document.querySelectorAll('input[item-id="1"], select[item-id="1"], textarea[item-id="1"]').forEach((input) => {
            input.addEventListener('change', (e) => {
                const row = e.target.closest('tr');
                if (row) {
                    const allFields = row.querySelectorAll('input, select, textarea');
                    const allBlank = Array.from(allFields).every(field => !field.value || field.value.trim() === '');
                    
                    if (allBlank) {
                        allFields.forEach((field) => {
                            toggleFieldAttributeV2(field, 'required', false);
                            validateField(field);
                        });
                    } else {
                        allFields.forEach((field) => {
                            if (!field.hasAttribute('required')) {
                                toggleFieldAttributeV2(field, 'required', true);
                            }
                        });
                    }
                }
            });
        });

        // Add business_name field to contact information section
        const contactInformationSection = document.getElementById('contact-information');
        if (contactInformationSection) {
            const businessNameWrapper = createElement("div", {
                class: "mb-3 _wrapper",
                "data-field-id": "_business_name",
                style: "width: 100%;"
            });
            
            const businessNameLabel = createElement("label", {
                for: "business_name",
            }, [], "Business Name (if applicable) <span class='error'></span>");
            
            const businessNameInput = createElement("input", {
                type: "text",
                class: "form-control",
                id: "business_name",
                name: "business_name",
                "data-validate": ""
            });
            
            businessNameWrapper.appendChild(businessNameLabel);
            businessNameWrapper.appendChild(businessNameInput);
            
            // Insert after full_name field or at the beginning of the section
            const fullNameWrapper = contactInformationSection.querySelector('#last_name').parentElement;
            fullNameWrapper.parentElement.insertBefore(businessNameWrapper, fullNameWrapper.nextSibling);
        }

        // Add business signature fields to certification section
        const certificationSection = document.getElementById('certification');
        if (certificationSection) {
            const signatureWrapper = certificationSection.querySelector('#signature').parentElement.parentElement;
            
            // Create a container div for the three fields in a row
            const businessFieldsRow = createElement("div", {
            class: "row mb-3"
            });
            
            // Business Signature field (col-4)
            const businessSignatureWrapper = createElement("div", {
                class: "col-md-4 _wrapper",
                "data-field-id": "_business_signature"
            });

            const businessInstructionP = createElement("div", {
                class: "mt-3"
            }, [], "<p>If submitting a business claim:</p>");

            businessFieldsRow.appendChild(businessInstructionP);
            
            const businessSignatureLabel = createElement("label", {
            for: "business_signature",
            }, [], "Signature (on behalf of business) <span class='error'></span>");
            
            const businessSignatureInput = createElement("input", {
                type: "text",
                class: "form-control",
                id: "business_signature",
                name: "business_signature",
                "data-validate": "",
                "data-label": "Signature (on behalf of business)",
            });
            
            businessSignatureWrapper.appendChild(businessSignatureInput);
            businessSignatureWrapper.appendChild(businessSignatureLabel);
            
            // Business Name field (col-4)
            const certBusinessNameWrapper = createElement("div", {
            class: "col-md-4 _wrapper",
            "data-field-id": "_cert_business_name"
            });
            
            const certBusinessNameLabel = createElement("label", {
            for: "cert_business_name",
            }, [], "Business Name <span class='error'></span>");
            
            const certBusinessNameInput = createElement("input", {
                type: "text",
                class: "form-control",
                id: "cert_business_name",
                name: "cert_business_name",
                "data-validate": "",
                disabled: true
            });
            
            certBusinessNameWrapper.appendChild(certBusinessNameInput);
            certBusinessNameWrapper.appendChild(certBusinessNameLabel);
            
            // Business Date field (col-4)
            const businessDateWrapper = createElement("div", {
            class: "col-md-4 _wrapper",
            "data-field-id": "_business_date"
            });
            
            const businessDateLabel = createElement("label", {
            for: "business_date",
            }, [], "Date <span class='error'></span>");
            
            const businessDateInput = createElement("input", {
                type: "text",
                class: "form-control",
                id: "business_date",
                name: "business_date",
                "data-validate": "",
                disabled: true
            });
            
            businessDateWrapper.appendChild(businessDateInput);
            businessDateWrapper.appendChild(businessDateLabel);
            
            // Append all three fields to the row
            businessFieldsRow.appendChild(businessSignatureWrapper);
            businessFieldsRow.appendChild(certBusinessNameWrapper);
            businessFieldsRow.appendChild(businessDateWrapper);
            
            // Insert the row after signature field's parent
            signatureWrapper.parentElement.insertBefore(businessFieldsRow, signatureWrapper.nextSibling);
        }

        // Move submit button to end of certification section
        const certification = document.getElementById('certification');
        const submitButton = document.getElementById('submit-claim');
        if (certification && submitButton) {
            certification.appendChild(submitButton);
        }

        document.getElementById('signature').parentElement.classList.remove('col-md-5');
        document.getElementById('signature').parentElement.classList.add('col-md-6');
        document.getElementById('date').parentElement.classList.remove('col-md-5');
        document.getElementById('date').parentElement.classList.add('col-md-6');
        submitButton.style.display = 'block';
        submitButton.style.margin = '0 auto';
        
        document.getElementById('business_name').addEventListener('input', (e) => {
            const businessName = e.target.value.trim();
            const certBusinessNameInput = document.getElementById('cert_business_name');
            const signatureInput = document.getElementById('signature');
            const certBusinessSignatureInput = document.getElementById('business_signature');
            certBusinessNameInput.value = businessName;

            if (businessName !== '') {
                toggleFieldAttributeV2(certBusinessSignatureInput, 'required', true);
                toggleFieldAttributeV2(signatureInput, 'required', false);
            } else {
                toggleFieldAttributeV2(certBusinessSignatureInput, 'required', false);
                toggleFieldAttributeV2(signatureInput, 'required', true);
            }

            validateField(signatureInput);
            validateField(certBusinessSignatureInput);
        });

        document.getElementById('business_signature').addEventListener('input', (e) => {
            validateField(e.target);
        });

        document.getElementById('business_date').value = document.getElementById('date').value;

        loadingGif(loading, "hide", 1000);
    }

    init_claim_inputs() {
        let claimInputsContact = '#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #user_language, #ag_SGUID, #ag_TEST';
        let claimInputsFields = '#claim-fields input:not([item-id]), #claim-fields textarea:not([item-id]), #claim-fields select:not([item-id]), #vet_name, #vet_facility_name, #vet_facility_address, #vet_facility_phone, #business_signature';
        let claimInputsFieldsPayment = '#payment_method, #payment_token, #payment_email, #payment_phone';
        let claimInputsTransactions = 'input[item-id], select[item-id], textarea[item-id]';

        this.claim.inputs.contact = Array.from(document.querySelectorAll(claimInputsContact));
        this.claim.inputs.fields = Array.from(document.querySelectorAll(claimInputsFields + ', ' + claimInputsFieldsPayment));
        this.claim.inputs.transactions = Array.from(document.querySelectorAll(claimInputsTransactions));
    }

    process_claim(e, claim, deadline) {
        console.log("[process_claim]")

        /**
         * Prevent the default form submission.
         * 
         * @var {Event} e - The submit event object.
         * @returns {void}
         */
        e.preventDefault();

        /**
         * Disable the submit button to prevent multiple submissions.
         * 
         * Since: 2023.09.25
         * 
         * @returns {void}
         */
        document.getElementById('submit-claim').disabled = true;

        // var claim = this.claim;
        if (claim.flags.sent) {
            return;
        }

        clearMessage();

        claim.flags.valid = true;
        claim.data.fields = {};

        this.init_claim_inputs();

        this.format_claim_data(claim);

        claim.data.contact.date = localDatetime();

        if (document.getElementById('documentation')) {
            this.process_claim_files(this.claim);
        }

        if (document.getElementById('email_address') && document.getElementById('confirm_email_address')) {
            ConfirmEmailAddress('process', this.claim);
        }

        // // if appPayMethod is defined and not empty, we run dstProcess from FormBase/DigitalDisbursements.js
        // if (appPayMethod && appPayMethod !== "" && this.customDstProcess === null) {
        //     claim = dstProcess(this.claim);
        // }
        // else if (appPayMethod && appPayMethod !== "" && this.customDstProcess !== null) {
        //     claim = this.customDstProcess(this.claim);
        // }

        /**
         * Define the environment for the s3 uploader.
         */
        let s3env = this.config.url;

        let custom_errors = '';

        let docs_required = false;
        let transaction_filled = false;

        document.querySelectorAll('#transactions-1 input, #transactions-1 select, #transactions-1 textarea, #transactions-4 input, #transactions-4 select, #transactions-4 textarea').forEach((input) => {
            if (input.value && input.value.trim() != '') {
                transaction_filled = true;
                docs_required = true;
                return;
            }
        });

        if (!transaction_filled) {
            document.querySelectorAll('#transactions-2 input, #transactions-2 select, #transactions-2 textarea, #transactions-3 input, #transactions-3 select, #transactions-3 textarea').forEach((input) => {
                if (input.value && input.value.trim() != '') {
                    transaction_filled = true;
                    return;
                }
            });
        }

        if (!transaction_filled) {
            custom_errors += `<br>Please fill out at least one table in Sections 3 or 4.`;
            claim.flags.valid = false;
        }

        let docs_uploaded = this.claim.prev_docs || claim.uploads.length > 0;
        if (docs_required && !docs_uploaded) {
            custom_errors += `<br>Please upload supporting documentation.`
            claim.flags.valid = false;
        }

        if (!document.getElementById('payment_method') || !document.getElementById('payment_token') || !document.getElementById('payment_method').value || !document.getElementById('payment_token').value) {
            custom_errors += `<br>${i18n.getTranslation('payment_select_error')}`;
            claim.flags.valid = false;
        }

        if (document.getElementById('email_address').value && document.getElementById('payment_email').value && document.getElementById('email_address').value.toLowerCase() != document.getElementById('payment_email').value.toLowerCase()) {
            custom_errors += `<br>${i18n.getTranslation('claim_processing_email_error')}`;
            claim.flags.valid = false;
        }

        if (document.getElementById('phone_number_1').value && document.getElementById('payment_phone').value && document.getElementById('phone_number_1').value.replace(/\D/g, '') != document.getElementById('payment_phone').value.replace(/\D/g, '')) {
            custom_errors += `<br>${i18n.getTranslation('claim_processing_phone_error')}`;
            claim.flags.valid = false;
        }

        if (claim.flags.valid) {
            grecaptcha.enterprise.execute(reCAPTCHAv3, { action: 'submit' }).then((token) => {
                claim.data.token = token;
                this.post_claim(claim, s3env);
            });
        } else {
            document.getElementById('submit-claim').disabled = false;
            var error = document.querySelector('label.error, #file-notice.error, #no-files.error');
            let timeout = 0;
            if (error && typeof error.scrollIntoView == 'function') {
                error.scrollIntoView({ behavior: "smooth" });
                timeout = 500;
            }
            setTimeout(() => {
                modal(i18n.getTranslation('error'), i18n.getTranslation('claim_form_errors') + custom_errors);
            }, timeout);
        }
    }

    async post_claim(claim, s3env) {
        console.log("[post_claim]");

        /**
         * Set the claim as sent.
         *
         * @returns {void}
         */
        claim.flags.sent = true;

        /**
         * Disable the submit button to prevent multiple submissions.
         *
         * Removed: 2023.09.25 (moved to process_claim) due to multiple submissions.
         *
         * @returns {void}
         */
        // document.getElementById('submit-claim').disabled = true;

        /**
         * Wait 0.5 seconds before display loading gif
         * (Lambda in sleep mode)
         *
         * @returns {void}
         */
        const t = window.setTimeout(() => {
            loadingGif(loading, "show");
        }, 250);

        // Update claim if an existing claim id
        if (claim.data.claim_id) {
            claim.flags.method = "claimsPut";
        }

        /**
         * Process the claim uploads and upload the files.
         */
        try {
            if (claim.uploads.length && claim.uploads.length > 0) {
                for (let f = 0; f < claim.uploads.length; f++) {
                    await uploadFile(claim, s3env, claim.uploads[f], f, 0);
                }
            }
        } catch (error) {
            this.errorHandler.log_exception(
                new Error("Error uploading claim files", { cause: error })
            );
            this.errorHandler.display_modal(error);
        }

        /**
         * Paul Pomerleau - October 18th, 2023
         * If the device has a local device token it's added to the claim fields before posting
         */
        const deviceToken = localStorage.getItem("X-Device-Token");
        if (deviceToken) claim.data.fields.device_token = deviceToken;

        // Post/Put claims data
        claim.api[claim.flags.method]({}, claim.data)
            .then(async function (result) {
                // Lambda error message
                if (result.data.error) {
                    clearTimeout(t);
                    claim.flags.success = false;
                    modal(i18n.getTranslation("error"), result.data.error);
                    return;
                }
                
                if (hasSimplifiedCampaignParams) {
                    gtag('event', 'claim_form_submitted', {
                        submission_time: Date.now(),
                        device_type: deviceType,
                        fraud_flagged: false,
                        send_to: 'G-0R933QHY1V'
                    }); 
                }

                /**
                 * Save correlation id
                 */
                claim.data.correlation_id = result.data.correlation_id;
                claim.flags.success = true;
            })
            .catch((error) => {
                this.errorHandler.log_exception(
                    new Error("Error posting claim", { cause: error })
                );
                this.errorHandler.display_modal(error);
                claim.flags.success = false;
                if (hasSimplifiedCampaignParams) {
                    gtag('event', 'claim_form_submitted', {
                        submission_time: Date.now(),
                        device_type: deviceType,
                        fraud_flagged: true,
                        send_to: 'G-0R933QHY1V'
                    });
                }
            })
            .finally(() => {
                // debugger;
                clearTimeout(t);
                loadingGif(loading, "hide", 250);
                if (claim.flags.success) {
                    this.destroy_claim(claim);
                } else {
                    document.getElementById("submit-claim").disabled = false;
                    claim.flags.sent = false;
                }

                // Remove editClaim link on Claim Confirmation
                const editClaim = document.getElementById("editClaim");
                if (editClaim !== null) {
                    editClaim.remove();
                }
            });
    }

    destroy_claim(claim) {
        loadingGif(loading, "hide", 500); // left here

        if (claim.flags.success) {
            claim.data.confirmation = this.claim_data_confirmation(claim.data);
            document.querySelector("div.display-form").classList.add("d-none");

            outputDiv.appendChild(this.claim_confirmation(claim.data));
            outputDiv.scrollIntoView({ behavior: "smooth" });

            setTimeout(() => {
                modal(
                    i18n.getTranslation("confirmation_screen_additional")[
                        "title"
                    ],
                    i18n.getTranslation("confirmation_screen_additional")[
                        "body"
                    ]
                );
            }, 250);

            fbq('track', 'Lead');
            gtag_report_conversion();
            if (hasSimplifiedCampaignParams) {
                gtag('event', 'confirmation_page_viewed', {
                    device_type: deviceType,
                    send_to: 'G-0R933QHY1V'
                });
            }
        } else {
            modal(
                i18n.getTranslation("error"),
                i18n.getTranslation("claim_submit_error")
            );
        }

        // Loop thru each input and disable to prevent changes and resubmissions
        for (const type in claim.inputs) {
            if (claim.inputs[type] && claim.inputs[type].length > 0) {
                claim.inputs[type].forEach(function (field) {
                    field.disabled = true;
                });
            }
        }

        [].forEach.call(
            document.querySelectorAll('input[type="radio"]'),
            function (radio) {
                radio.setAttribute("disabled", "disabled");
            }
        );

        document
            .getElementById("submit-claim")
            .setAttribute("disabled", "disabled");
    }
}